import { isEmpty } from 'lodash-es';

import { YesNoFilter } from './yes-no-filter';
import { Filter } from '../filter';
import { TextFilter } from '../text/text-filter';

export class YesNoTextInputFilter extends Filter {
  yesNo: YesNoFilter;
  textInput: TextFilter;

  constructor(yesNo, textInput) {
    super(null);
    this.yesNo = yesNo;
    this.textInput = textInput;
  }

  queryParams() {
    const params: any = {};

    if (this.yesNo?.queryParams()) {
      params.yesNo = this.yesNo.queryParams();
    }

    if (this.textInput?.queryParams()) {
      params.textInput = this.textInput.queryParams();
    }

    if (!isEmpty(params)) {
      return params;
    }

    return null;
  }

  get status() {
    let filterCount = 0;
    if (this.yesNo?.status && this.textInput?.status) {
      filterCount = 2;
    } else if (this.yesNo?.status || this.textInput?.status) {
      filterCount = 1;
    }
    return filterCount;
  }

  set(params) {
    if (!params) {
      this.reset();
      return;
    }

    if (this.yesNo) {
      this.yesNo.set(params.yesNo);
    }

    if (this.textInput) {
      this.textInput.set(params.textInput);
    }
  }

  reset() {
    if (this.yesNo) {
      this.yesNo.reset();
    }
    if (this.textInput) {
      this.textInput.reset();
    }
  }
}
